import type {PermissionsRecordType} from '../permissions';

export const salesLeaguePermissions = {
  salesLeagueRead: {
    resourceId: 'SALES_LEAGUE',
    actionId: 'READ',
    scopes: [],
  },
  /**
   * The branch board. Granted to nobody by default — manager-role users hold it
   * implicitly, other roles only if the tenant grants it. A viewer without it keeps the
   * rep leaderboard as a single plain sidebar entry, which is the intended outcome rather
   * than an error state.
   */
  salesLeagueBranchBoardRead: {
    resourceId: 'SALES_LEAGUE',
    actionId: 'READ_BRANCH_BOARD',
    scopes: [],
  },
} satisfies PermissionsRecordType;
